import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { AiSparkleBoldIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorSurfaceActionMeetingIntelligence } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spotlight } from 'components/core/spotlight';
import { clearReminderSpotlight, shouldShowReminderSpotlight, PulsingOrb } from 'features/meeting_intelligence';
const mIAwarenessButtonCss = "m1tmqcq0";
const MIAwarenessButton = forwardRef((props, ref) => <MinimalButton ref={ref} {...props} className={classNames(mIAwarenessButtonCss, props.className)} />);
const styledSpotlightCss = "s3uhv3g";
const StyledSpotlight = forwardRef((props, ref) => <Spotlight ref={ref} {...props} className={classNames(styledSpotlightCss, props.className)} />);
const NotetakerButton = ({
  handleOnClick,
  isMobile
}) => <MIAwarenessButton size="small" onClick={handleOnClick} aria-label={I18n.t('publisher.billing.meeting_intelligence.get_notetaker')}>
    <AiSparkleBoldIcon />
    {!isMobile && <span>{I18n.t('publisher.billing.meeting_intelligence.get_notetaker')}</span>}
  </MIAwarenessButton>;
const NotetakerButtonWithSpotlight = ({
  handleOnClick,
  isMobile,
  handleSpotlightClick
}) => <MinimalButton onClick={handleOnClick} aria-label={I18n.t('publisher.billing.meeting_intelligence.get_notetaker')}>
    <AiSparkleBoldIcon color={colorSurfaceActionMeetingIntelligence} />
    <PulsingOrb isVisible />
    {!isMobile && <BodyText color={colorSurfaceActionMeetingIntelligence}>
        {I18n.t('publisher.billing.meeting_intelligence.get_notetaker')}
      </BodyText>}
    <StyledSpotlight bodyText={HtmlParser(I18n.t('publisher.meeting_intelligence.spotlight.reminder_spotlight.body'))} onClose={handleSpotlightClick} onClickPrimary={handleSpotlightClick} placement="bottom-left" offset={20} outsideClickDetectionEnabled={false} showClose={false} primaryButtonLabel={I18n.t('publisher.meeting_intelligence.spotlight.reminder_spotlight.button')} theme="meeting_intelligence_simplified" />
  </MinimalButton>;
export const AINotetakerButton = ({
  onClick,
  isMobile: isMobileProp
}) => {
  const dispatch = useDispatch();
  const isReminderSpotlight = useSelector(shouldShowReminderSpotlight);
  const handleSpotlightClick = () => {
    dispatch(clearReminderSpotlight());
  };
  const handleOnClick = () => {
    onClick();
  };
  const isMobileDeviceType = useDeviceType('isPhone');
  const isMobile = isMobileProp !== undefined ? isMobileProp : isMobileDeviceType;
  return isReminderSpotlight ? <NotetakerButtonWithSpotlight isMobile={isMobile} handleOnClick={handleOnClick} handleSpotlightClick={handleSpotlightClick} /> : <NotetakerButton isMobile={isMobile} handleOnClick={handleOnClick} />;
};

require("./a-i-notetaker-button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./a-i-notetaker-button.js");